import { React, styled } from '../lib/imports';
import { useSelector } from 'react-redux';
import { ColorProvider, Image, Text } from '../components';
import { useCdnImage } from '../app/context/config';

import HeatStreak from '../heatStreak/HeatStreak';

const EmptyStateContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 400px;
  padding: 70px 20px;
`;

const ImageContainer = styled('div')`
  width: 52px;
  height: 52px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const EmptyStateText = styled(Text)`
  text-align: center;
  color: ${({ theme }) => theme.colors.n650};
`;

const History = () => {
  const { strings, heatStreak } = useSelector((state) => state);

  const historyData = heatStreak?.byDate || {};
  const historyDates = Object.keys(historyData);
  const resultsMissing = historyDates.length === 0;

  const emptyHistoryMessage = strings['history/empty/title'];
  const cdnImages = useCdnImage(['hockeySticks']);

  return (
    <ColorProvider cssProp='background' variant='lightGrey'>
      {resultsMissing ? (
        <EmptyStateContainer>
          <ImageContainer>
            <Image src={cdnImages.hockeySticks} alt='Empty state image' />
          </ImageContainer>
          <EmptyStateText size='peta'>{emptyHistoryMessage}</EmptyStateText>
        </EmptyStateContainer>
      ) : (
        <HeatStreak />
      )}
    </ColorProvider>
  );
};

export default History;
